
export const formatDate = (dateParams) => {
  /** 現在時刻を取得 */
  const date = dateParams ? new Date(dateParams) : new Date();
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const formatted = `${y}年${m}月${d}日`;
  /** 現在時刻を取得*/
  return formatted;
}